import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetIntegrationLogById } from '../../../../api/settingsService';
import {
  IntegrationLogDetailModal,
  useCrmRecordLinkConfig,
} from '../../../../components/IntegrationLog';
import { ROUTES } from '../../../../constants';

/**
 * Route wrapper around {@link IntegrationLogDetailModal} — resolves the log from
 * the `:id` route param and closes by returning to the list.
 */
export const IntegrationLogDetailModalRoute = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Preserve any active list filters (e.g. ?sourceId=...) so closing the modal
  // returns the user to the same filtered list they came from.
  const listRoute = `${ROUTES.SETTINGS_INTEGRATION_LOG}${location.search}`;
  const onClose = () => navigate(listRoute);

  const { data: logItem, isLoading } = useGetIntegrationLogById(id, {
    // On a missing/deleted/inaccessible id, toast and redirect back to the list.
    meta: {
      showErrorToast: true,
      navigateTo: listRoute,
      replace: true,
    },
  });
  const externalRecordLinkConfig = useCrmRecordLinkConfig();

  return (
    <IntegrationLogDetailModal
      isOpen
      logItem={logItem}
      isLoading={isLoading}
      onClose={onClose}
      externalRecordLinkConfig={externalRecordLinkConfig}
    />
  );
};
